// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sizeExceededModalPaper__Bdy1Y.sizeExceededModalPaper__Bdy1Y {
  width: 100%;
  margin: 20px;
  padding: 20px;
  border-radius: 16px;
}

.sizeExceededModalPaper__Bdy1Y.sizeExceededModalPaper__Bdy1Y h2 {
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0;

  font-size: 18px;
  font-weight: 500;
  font-style: normal;
  line-height: 22px;
}

.sizeExceededModalContent__RRIVp.sizeExceededModalContent__RRIVp {
  padding: 16px 0 !important;
}

.sizeExceededModalContent__RRIVp.sizeExceededModalContent__RRIVp p {
  font-size: 14px;
  line-height: 22px;
  color: #262732;
}

.sizeExceededModalActions__Z08hP.sizeExceededModalActions__Z08hP {
  padding: 0;
}

.sizeExceededModalButton__zdxOH.sizeExceededModalButton__zdxOH {
  height: 38px;
  margin-left: 16px !important;
  padding: 8px 16px;

  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  color: #fff;
  text-transform: none;

  border-radius: 19px;
}

.sizeExceededModalButton__zdxOH.sizeExceededModalButton__zdxOH:hover {
  opacity: 0.9;
}
`, "",{"version":3,"sources":["webpack://./src/components/Chat/ChatInput/SizeExceededModal.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;;EAE9B,UAAU;;EAEV,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,iBAAiB;;EAEjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,oBAAoB;;EAEpB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".sizeExceededModalPaper.sizeExceededModalPaper {\n  width: 100%;\n  margin: 20px;\n  padding: 20px;\n  border-radius: 16px;\n}\n\n.sizeExceededModalPaper.sizeExceededModalPaper h2 {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  padding: 0;\n\n  font-size: 18px;\n  font-weight: 500;\n  font-style: normal;\n  line-height: 22px;\n}\n\n.sizeExceededModalContent.sizeExceededModalContent {\n  padding: 16px 0 !important;\n}\n\n.sizeExceededModalContent.sizeExceededModalContent p {\n  font-size: 14px;\n  line-height: 22px;\n  color: #262732;\n}\n\n.sizeExceededModalActions.sizeExceededModalActions {\n  padding: 0;\n}\n\n.sizeExceededModalButton.sizeExceededModalButton {\n  height: 38px;\n  margin-left: 16px !important;\n  padding: 8px 16px;\n\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 22px;\n  color: #fff;\n  text-transform: none;\n\n  border-radius: 19px;\n}\n\n.sizeExceededModalButton.sizeExceededModalButton:hover {\n  opacity: 0.9;\n}\n"],"sourceRoot":""}]);
// Exports
export var sizeExceededModalPaper = `sizeExceededModalPaper__Bdy1Y`;
export var sizeExceededModalContent = `sizeExceededModalContent__RRIVp`;
export var sizeExceededModalActions = `sizeExceededModalActions__Z08hP`;
export var sizeExceededModalButton = `sizeExceededModalButton__zdxOH`;
export default ___CSS_LOADER_EXPORT___;
